<template>
  <v-container class="fill-height">
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "ProjectIndex"
};
</script>

<style scoped></style>
